export enum InvestigatingStatus {
  Investigating = 0,
  Pursue = 1,
  NCM = 2,
  Skip = 3
}

export const InvestigatingStatusMapping: Record<InvestigatingStatus, string> = {
  [InvestigatingStatus.Investigating]: 'Investigate',
  [InvestigatingStatus.Pursue]: 'Pursue',
  [InvestigatingStatus.NCM]: 'NCM',
  [InvestigatingStatus.Skip]: 'Skip'
};


export const InvestigatingSkipArray: InvestigatingStatus[] = [
  InvestigatingStatus.Skip,
  InvestigatingStatus.NCM
];